import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
name: 'shop',
directives: {
TransferDom
},
components: {
Tab,
TabItem,
XButton,
Confirm,
Popup,
Swiper,
SwiperItem,
},
data () {
return {
isPriceSort: false,
isSalesSort: false,
isLatestSort: false,
mescroll: null,
dataList: [],
page: 1,
postStatus: 'price',
postOrderDesc: 'asc',
categoryId: '',
showCategory: false,
showSearch: false,
CategoryList: [],
parentActive: -1,
childActive: -1,
searchWord: '',
scrollTop: 0
}
},
methods: {
synthesizeSort () { //综合排序
this.$vux.loading.show({
text: ''
})

this.list = []
this.page = 1
this.postStatus = 'synthesize'
if(this.postOrderDesc == 'asc'){
this.postOrderDesc = 'desc'
}else{
this.postOrderDesc = 'asc'
}
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
priceSort () { //价格
this.isPriceSort = !this.isPriceSort
this.$vux.loading.show({
text: ''
})

this.list = []
this.page = 1
this.postStatus = 'price'
if(this.isPriceSort){
this.postOrderDesc = 'asc'
}else{
this.postOrderDesc = 'desc'
}
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
salesSort () { //销量
this.isSalesSort = !this.isSalesSort
this.$vux.loading.show({
text: ''
})

this.list = []
this.page = 1
this.postStatus = 'saleqty'
if(!this.isSalesSort){
this.postOrderDesc = 'asc'
}else{
this.postOrderDesc = 'desc'
}
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
latestSort () { //最新
this.isLatestSort = !this.isLatestSort
this.$vux.loading.show({
text: ''
})

this.list = []
this.page = 1
this.postStatus = 'createdtime'
if(!this.isLatestSort){
this.postOrderDesc = 'asc'
}else{
this.postOrderDesc = 'desc'
}
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},

































detail (item) {
this.$router.push({
path: '/commodity',
query: {
id: item.id,

}
})
},
getCategoryList () {
this.$request.post('/category/treelist',{

}).then(data => {
if(data.code == 0){
console.log(data)
this.CategoryList = data.obj.children
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
onScroll (pos) {
this.scrollTop = pos.top
},
parentClick (item, index) { //点击一级分类
this.childActive = -1
this.parentActive == index ? this.parentActive = -1 : this.parentActive = index
console.log(item)
if(!item.children){
this.parentActive = index
this.showCategory = false;
this.categoryId = item.id
this.list = []
this.page = 1
this.postStatus = 'synthesize'
this.$vux.loading.show({
text: ''
})
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
}
},
childClick (item2, index2) { //点击二级分类
this.childActive = index2
this.showCategory = false;
this.categoryId = item2.id
this.list = []
this.page = 1
this.postStatus = 'synthesize'
this.$vux.loading.show({
text: ''
})
this.mescroll.resetUpScroll()
this.mescroll.scrollTo( 0, 0 )
},
changeColor (resultsList) {
resultsList.map((item, index) => {

if (this.keyWords && this.keyWords.length > 0) {

let replaceReg = new RegExp(this.keyWords, 'g')

let replaceString =
'<span class="search-text">' + this.keyWords + '</span>'
resultsList[index].name = item.name.replace(
replaceReg,
replaceString
)
}
})
this.results = []
this.results = resultsList
},
search () {
this.showSearch = false
this.$vux.loading.show({
text: ''
})
this.mescroll.scrollTo( 0, 0 )
this.dataList = []
this.page = 1
this.postStatus = 'synthesize'

this.$request.post('/search/listProduct',{
page: this.page,
rows: 100,

obj: {
orderType: this.postStatus + '|' + this.postOrderDesc,

searchContent: this.searchWord
}
}).then(data => {
this.mescroll.removeEmpty();
if(data.code == 0){
this.mescroll.lockUpScroll( true )
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
let that = this
data.obj.rows.map((item, index) => {

if (that.searchWord && that.searchWord.length > 0) {

let replaceReg = new RegExp(that.searchWord, 'g')

let replaceString =
'<span class="search-text">' + that.searchWord + '</span>'
data.obj.rows[index].spuName = item.spuName.replace(
replaceReg,
replaceString
)
}
})
this.dataList = this.dataList.concat(data.obj.rows)
if(this.dataList.length == 0){
this.mescroll.showEmpty()
}
this.$vux.loading.hide()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
this.$vux.loading.hide()
}
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e
})
this.$vux.loading.hide()
})
console.log(this.searchWord)
},

upCallback (page) {

this.getListDataFromNet(this.pdType, page.num, page.size, (arr) => {

if (page.num === 1) this.dataList = []

this.dataList = this.dataList.concat(arr)

this.$nextTick(() => {
this.mescroll.endSuccess(arr.length)

this.$vux.loading.hide()

})
}, () => {
this.mescroll.endErr()
})
},
/* 联网加载列表数据
* 在您的实际项目中,请参考官方写法: http://www.mescroll.com/api.html#tagUpCallback
* 请忽略getListDataFromNet的逻辑,这里仅仅是在本地模拟分页数据,本地演示用
* 实际项目以您服务器接口返回的数据为准,无需本地处理分页.
*/
getListDataFromNet (pdType, pageNum, pageSize, successCallback, errorCallback) {
console.log(22)
this.mescroll.lockUpScroll( false )
this.$request.post('/category/products',{
page: pageNum,
rows: pageSize,

obj: {
orderType: this.postStatus + '|' + this.postOrderDesc,
categoryId: this.categoryId
}
}).then(data => {
if(data.code == 0){
setTimeout(() => {

var listData = []
for (var i = (pageNum - 1) * pageSize; i < pageNum * pageSize; i++) {
if (i === data.obj.total) break
listData.push(data.obj.rows[i-(pageNum - 1) * pageSize])
}
successCallback(listData)
}, 350);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
initMescrollFun () {

this.mescroll = new MeScroll(this.$refs.mescroll, { // 在vue的mounted生命周期初始化mescroll,确保此处配置的ref有值
up: {
callback: this.upCallback,
htmlNodata: '<p class="upwarp-nodata">没有更多产品</p>',
page: {
num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
size: 10 
},
noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
toTop: { // 配置回到顶部按钮
src: require('../../assets/images/mescroll-totop.png'),
offset: 100
},
empty: {

warpId:	"dataList", //父布局的id (1.3.5版本支持传入dom元素)
icon: require('../../assets/images/mShopN.png'), //图标,默认null,支持网络图
tip: "暂无相关数据~", //提示
},



},
down: {
offset: 40,
}
})
},
fullReduction () {
this.$router.push({
path: '/fullReduction'
})
}
},
created () {
this.getCategoryList()
},
mounted() {
this.initMescrollFun()
},
beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
next(vm => {
if (vm.mescroll) {

if (vm.mescroll.lastBounce != null) vm.mescroll.setBounce(vm.mescroll.lastBounce)

if (vm.mescroll.lastScrollTop) {
vm.mescroll.setScrollTop(vm.mescroll.lastScrollTop)
setTimeout(() => { // 需延时,因为setScrollTop内部会触发onScroll,可能会渐显回到顶部按钮
vm.mescroll.setTopBtnFadeDuration(0)
}, 16)
}
}
})
},
beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
if (this.mescroll) {
this.mescroll.lastBounce = this.mescroll.optUp.isBounce
this.mescroll.setBounce(true) 
this.mescroll.lastScrollTop = this.mescroll.getScrollTop() 
this.mescroll.hideTopBtn(0)
}
next()
},
}



// WEBPACK FOOTER //
// ./src/views/shop/script.js